import React, {useCallback, useEffect, useState} from "react";
import {addItemToCart, updateItemQuantity} from "../../store/cart-slice";
import {useDispatch, useSelector} from "react-redux";
import Filters from "./Filters";
import ProductListItem from "./ProductListItem";


const filterAndSortItems = (items) => {
    const filteredItems = items.some(item => typeof item.stock === "number" && !isNaN(item.stock))
        ? items.filter(item => typeof item.stock !== "number" || item.stock > 0)
        : items;

    return filteredItems.sort((a, b) => {
        const aFav = a.tags?.some(tag => tag.name === "Favourite") ? 1 : 0;
        const bFav = b.tags?.some(tag => tag.name === "Favourite") ? 1 : 0;
        return bFav - aFav;
    });
};

const ProductList = ({editableItem=[], isEditable= false}) => {
    const dispatch = useDispatch();
    const cartItems = useSelector((state) => state.cart.items);
    const getCartItem = (itemId) => cartItems.find(item => item.productId === itemId);
    const {
        items,
        fetchStatus,
        error: fetchError
    } = useSelector((state) => state.product);

    const [products, setProducts] = useState(items);

    const handleAddToCart = (item) => {
        if (item.stock > 0 || item.stock === undefined || isNaN(item.stock)) {
            dispatch(addItemToCart({...item, quantity: 1}));
        }
        else {
            alert("Out of stock.");
        }
    };

    const handleIncreaseQuantity = (itemId, stock) => {
        const cartItem = getCartItem(itemId);
        if (cartItem && (cartItem.quantity < stock || !Number.isFinite(stock))) {
            dispatch(updateItemQuantity({id: itemId, change: 1, stock}));
        } else {
            alert(`Cannot add more than ${stock} items.`);
        }
    };

    const handleDecreaseQuantity = (itemId, stock) => {
        dispatch(updateItemQuantity({id: itemId, change: -1, stock}));
    };

    const handleFilterChange = useCallback((filteredItems) => {
        const updatedItems = filterAndSortItems(filteredItems);
        setProducts(updatedItems);
    }, []);

    useEffect(() => {
        const updatedItems = filterAndSortItems(items);
        setProducts(updatedItems);
    }, [items]);

    return (
        <>
            <Filters items={items} onFilterChange={handleFilterChange}/>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{fetchError}</h6>}
            {fetchStatus === "success" &&
                <div className="row g-5">
                    {products.length > 0 ? (
                        products.map((item) => {
                        const cartItem = getCartItem(item.id);
                        const quantity = cartItem?.quantity || 1;
                        return (
                                <ProductListItem
                                    key={item.id}
                                    item={item}
                                    cartItem={cartItem}
                                    quantity={quantity}
                                    onIncreaseQuantity={handleIncreaseQuantity}
                                    onDecreaseQuantity={handleDecreaseQuantity}
                                    onAddToCart={handleAddToCart}
                                />
                            );
                        })
                    ) : (
                        <p>Products not found</p>
                    )}
                </div>
            }
        </>
    );
};

export default ProductList;
